module.exports = __webpack_public_path__ + "img/demo.a815acd6.png";